import { render, staticRenderFns } from "./UpdatePlanBeam.vue?vue&type=template&id=47603b18&"
import script from "./UpdatePlanBeam.vue?vue&type=script&lang=js&"
export * from "./UpdatePlanBeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports